export const isEmbedded = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
